<template>
    <div class="conter">
        <div class="title">新风系统选型配置</div>
        <div class="currency_suggest">
            <div class="titel">
                <span>设计依据</span>
            </div>
            <div class="title_xiao">新风需求</div>
            <div class="demand">
                <div class="demand_conter">
                    <div class="demand_top">
                        <div class="situat_item">
                            <span class="label">风口</span>
                            <span class="room_type">{{
                                reporInfo.numWindKou != undefined
                                    ? reporInfo.numWindKou + "个"
                                    : "0" + "个"
                            }}</span>
                        </div>
                        <div class="situat_item">
                            <span class="label">换气面积</span>
                            <span class="room_type">{{
                                Number(reporInfo.numWindArea).toFixed(1) + "m²"
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="personnel" v-if="bShowFreshsText">
                    <div
                        class="personnel_conter"
                        v-for="(item, index) in reporInfo.tags"
                        v-show="item.type == 3"
                        :key="index"
                    >
                        <div class="per_laber">
                            <span :class="['btn_laber', item.nameClass]">{{
                                item.name
                            }}</span>
                            <span
                                class="eait"
                                v-if="!reporInfo.bShowCard"
                                @click="
                                    getEait(
                                        item.strDeasFreshs,
                                        item.type,
                                        index,
                                        item.tag_freshs_id
                                    )
                                "
                            ></span>
                        </div>
                        <div
                            class="per_textar"
                            v-html="item.strDeasFreshs"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="currency_suggest">
            <div class="titel">
                <span>系统选型</span>
            </div>
            <div class="title_xiao" v-if="reporInfo.arrFreshsSub.length">
                系统设备配置
            </div>
            <div>
                <div class="lytab_sub" v-for="(item,index) in reporInfo.arrFreshsSub" :key="index">
                    <div class="lytab" v-if="reporInfo.arrFreshsSub.length > 1">
                        <div class="lytab_list" style="width:100%;">
                            <div class="arrRooms">
                                <div class="actRoomNav roomNav" style="width:100%;">
                                    {{ item.room | roomNumber }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 楼层切换展示无需，需要时打开 -->
                    <!-- <div class="lytab" v-if="reporInfo.arrFreshsSub.length > 1">
                        <div
                            class="lytab_list"
                            :style="{
                                width: reporInfo.arrFreshsSub.length < 5 ? '100%' : '',
                            }"
                        >
                            <div class="arrRooms">
                                <div
                                    :class="[
                                        nRoomIndex == index ? 'actRoomNav' : '',
                                        reporInfo.arrFreshsSub.length < 5
                                            ? 'roomNav'
                                            : 'xRoomNav',
                                    ]"
                                    :style="{
                                        width:
                                            reporInfo.arrFreshsSub.length < 5
                                                ? 100 / reporInfo.arrFreshsSub.length +
                                                '%'
                                                : '',
                                    }"
                                    v-for="(item, index) in reporInfo.arrFreshsSub"
                                    :key="index"
                                    @click="getRoom(index)"
                                >
                                    {{ item.room | roomNumber }}
                                </div>
                            </div>
                            <div :class="['second_nav_strip']">
                                <div
                                    :class="[
                                        reporInfo.arrFreshsSub.length < 5
                                            ? 'strip'
                                            : 'nostrips',
                                    ]"
                                    :style="{
                                        left:
                                            (100 / reporInfo.arrFreshsSub.length) *
                                                nRoomIndex +
                                            '%',
                                        width:
                                            reporInfo.arrFreshsSub.length < 5
                                                ? 100 / reporInfo.arrFreshsSub.length +
                                                '%'
                                                : '',
                                    }"
                                ></div>
                            </div>
                        </div>
                    </div> -->
                    <div class="selection">
                        <div class="selection_conter">
                            <div class="situat_item" style="width: 38%">
                                <span class="label">换气次数</span>
                                <span class="room_type">{{
                                    reporInfo.arrFreshsSub.length
                                        ? Number(item.wind_exchange) + "次"
                                        : "0次"
                                }}</span>
                            </div>
                            <div class="situat_item">
                                <span class="label">新风需求风量</span>
                                <span class="room_type">{{
                                    Number(item.wind_energy).toFixed(1) + "m³/hp"
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="shopp_conter" v-if="reporInfo.arrFreshsSub.length">
                        <div
                            class="shopp_list"
                            v-for="(items, indexs) in item.arrFreshs"
                            @click="getDetails(items.product_id)"
                            :key="indexs"
                        >
                            <div class="shopp_top">
                                <div class="type">{{ items.new_goods_type_name }}</div>
                                <div>{{ items.goods_name }}</div>
                            </div>
                            <div class="shopp_bottom">
                                <div class="shopp_img">
                                    <img v-lazy="items.mobile_img" alt="" />
                                </div>
                                <div class="num">{{ "x" + items.num }}</div>
                                <div class="shopp_attr">
                                    <div
                                        class="situat_item"
                                        v-for="(attritem, attrindex) in items.attr_two"
                                        :key="attrindex"
                                    >
                                        <span class="label">{{
                                            attritem.attr_name
                                        }}</span>
                                        <span class="room_type">{{
                                            attritem.attr_value
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <textInput
            :bShowIput.sync="bShowIput"
            :sText.sync="sText"
            :nType.sync="nType"
            :nIndex.sync="nIndex"
            :tagId.sync="tagId"
            :category.sync="category"
            @sumbit="sumbitzi"
        ></textInput>
    </div>
</template>
<script>
import textInput from "../../components/textinput/index";
export default {
    components: {
        textInput,
    },
    props: {
        bShowFreshsText: {
            type: Boolean,
            default: false,
        },
        reporInfo: {
            type: Object,
            default: false,
        },
    },
    data() {
        return {
            category: 2,
            nRoomIndex: 0,
            bShowIput: false,
            nType: 0, //类型
            sText: "", //需要修改的文本
            nIndex: 0,
            tagId: 0,
            arrDemand: [
                {
                    name: "人员需求",
                    nameClass: "one_icon",
                    text: "6口之家；包含体弱长辈、儿童及体寒女性；老人体质较弱，易患关节疼痛等疾病；孩子抗力较弱，容易着凉；女士体寒怕冷；为了保证身体健康，冬季需要更温暖的室内环境；",
                },
                {
                    name: "作息需求",
                    nameClass: "two_icon",
                    text: "业主是上班族，白天不在家，采暖仍需24小时开启，无人期间能源白白消耗；客厅、餐厅、厨房等区域，晚上“**”、“***”等区域，每天仅少量时间使用，临时开启，需等待很长加热时间；",
                },
                {
                    name: "冬季室温需求",
                    nameClass: "three_icon",
                    text: "室温需保持在18℃左右，保证不穿外套自由活动；主卧室、老人房、儿童房20℃左右；",
                },
                {
                    name: "夏季室温需求",
                    nameClass: "four_icon",
                    text: "室温需保持在26℃左右，可分区温控；",
                },
            ],
        };
    },
    filters: {
        roomNumber(index) {
            // console.log("-->计算属性", index);
            let arr = [
                "一",
                "二",
                "三",
                "四",
                "五",
                "六",
                "七",
                "八",
                "九",
                "十",
            ];
            if (index < 0) {
                return "地下室" + arr[Number(-index) - 1] + "层";
            } else if (index <= 10 && index > 0) {
                return arr[Number(index) - 1] + "层";
            }
        },
    },
    methods: {
        getRoom(index) {
            this.nRoomIndex = index;
        },
        //查看商品详情
        getDetails(id) {
            this.$router.push({ path: `/shopp/details?id=${id}` });
        },
        sumbitzi(e) {
            // console.log("sumbit", e);
            this.$emit("sumbitzi", e);
        },
        //点击编辑文本
        getEait(html_deas, type, index, tag_freshs_id) {
            this.nIndex = Number(index);
            // console.log(this.nIndex, index);
            this.tagId = tag_freshs_id;
            this.nType = type;
            this.sText = html_deas.replace(/<br\/>/g, "\r\n");
            this.bShowIput = true;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>